module.exports = __webpack_public_path__ + "img/fankun.cf3ce326.png";